export declare class PermissionEntity {
  public value: string;
  public permissions?: PermissionEntity[];
}
